import { useEffect } from 'react';

const InstagramCallback = () => {
  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');
    if (code && window.opener) {
        console.log('here')
      window.opener.postMessage({ 
        type: 'instagram-auth', 
        code 
      }, window.location.origin);
      window.close();
    }
  }, []);

  return null;
};

export default InstagramCallback;